export default "__VITE_ASSET__98de46d6__"